<template>
  <v-card flat class="bucket-field" @click="clickHandler()">
    <v-layout row>
      <v-layout column>
        <!-- <h5 class=" ml-1 pa-1 caption" style="opacity:0.54" v-if="header.text !== ''">{{ header.text }}</h5> -->
        <div :class="'px-2 bucket-field-value text-truncate ' + fieldClass">
          {{ data.value ? data.value : "-" }}
        </div>
      </v-layout>
      <router-link v-if="header.hasLink && data.route" style="text-decoration:none;" :id="'link-' + data.value" :to="data.route">
        <v-btn icon :disabled="!data.route">
          <font-awesome-icon class="ma-0" size="1x" :icon="['fas', 'link']"></font-awesome-icon>
        </v-btn>
      </router-link>
      <v-icon v-if="header.serviceLevel" class="mr-1" :color="slaColour">
        notifications_active
      </v-icon>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: "bucket-table-field",
  props: ["data", "header"],
  computed: {
    fieldClass() {
      if (this.header) {
        if (this.header.rightAlign && this.data.value) {
          return "right"
        }
        if (this.header.hasDocument && this.data.value !== "-") {
          return "document"
        }
        if (this.header.hasLink) {
          return "linked"
        }
        if (this.header.serviceLevel) {
          if (this.data && this.data.sla) {
            if (this.data.sla.breachedAt) {
              return "sla-breach"
            }
            if (this.data.sla.jeopardizedAt) {
              return "sla-jeopardy"
            }
          }
          return "sla-default"
        }
      }
      return ""
    },
    slaColour() {
      if (this.data.sla && this.data.sla.breachedAt) {
        return "error"
      } else if (this.data.sla && this.data.sla.jeopardizedAt) {
        return "tertiary"
      } else {
        return "info"
      }
    },
  },
  methods: {
    async clickHandler() {
      if (this.header.hasDocument && (this.data.documentRoute || this.data.route)) {
        const docRoute = this.data.documentRoute || this.data.route
        const auth = "Bearer " + window.localStorage.session
        const anchor = document.createElement("a")
        document.body.appendChild(anchor)
        const headers = new Headers()
        headers.append("Authorization", auth)
        const route = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${docRoute}` : docRoute
        const response = await fetch(route, { headers })
        const blobby = await response.blob()
        const objectUrl = window.URL.createObjectURL(blobby)
        anchor.href = objectUrl
        anchor.target = "blank"
        anchor.click()
      }
    },
  },
}
</script>

<style>
#bucketedit-main .layout.fixed-header-wrapper .v-btn--icon {
  width: 36px;
  height: 36px;
}

.v-btn--icon {
  width: 21px;
  height: 21px;
}

.bucket-field {
  /* padding: 5px 2px 0 5px !important; */
  margin-bottom: 4px;
  background-color: #f3f2f1 !important;
  border-bottom: 1px solid #ebebeb !important;
}

.bucket-field:hover {
  background-color: #efefef !important;
  border-bottom: 1px solid black !important;
}

.bucket-field-value {
  white-space: nowrap;
  min-width: 150px;
  padding: 10px;
}

.bucket-field .right {
  text-align: right !important;
}

.bucket-field .linked {
  min-width: 150px;
  max-width: 220px;
}

.bucket-field .sla-default {
  margin-right: 10px;
  color: #6499a6 !important;
}

.bucket-field .sla-jeopardy {
  margin-right: 10px;
  color: #f19916 !important;
}

.bucket-field .sla-breach {
  margin-right: 10px;
  color: #db444d !important;
}

.bucket-field .document {
  min-width: 180px;
  text-decoration: underline;
}
.bucket-field .document:hover {
  cursor: pointer;
}
</style>
